module.exports = __webpack_public_path__ + "img/pic_australia_05.a21c999c.jpg";